import styled from 'styled-components';

export const PrivacyContainer = styled('div')``;
